<template>
    <div
        @click="onClick"
        class="relative flex cursor-pointer items-center px-6 py-4 transition-colors hover:bg-black/10">
        <lz-icon v-if="selected" name="close-rize" class="absolute -ml-4 h-2 w-2 stroke-current" />
        <slot>
            <span class="text-sm capitalize leading-4">{{ title }}</span>
        </slot>
    </div>
</template>
<script setup lang="ts">
import LzIcon from './LzIcon.vue';
import { defineProps, withDefaults } from 'vue';

const props = withDefaults(
    defineProps<{
        value: never;
        title: string;
        selected?: boolean;
        multiple?: boolean;
    }>(),
    {
        title: '',
        selected: false,
        multiple: false
    }
);
const emit = defineEmits(['select']);

function onClick() {
    emit('select', { value: props.value, label: props.title, selected: props.selected });
}
</script>
